import { Loader2 } from "lucide-react";
import { useAuthStep } from "@/hooks/useAuthStep";
import { CredentialResponse, GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { useEffect } from "react";
import { useGoogleAuth } from "@/hooks/useGoogleAuth";
import { useCommunication } from "@/lib/CommunicationWrapper";


const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || "";

const LoginGoogle = () => {
    const { handleAuth, loginState, setAuthStep, hasCompletedSignup } = useAuthStep();
    const { googleLogin } = useGoogleAuth();
    const { updateOptions } = useCommunication();


    const handleGoogleLogin = (tokenResponse: CredentialResponse) => {
        const authFn = googleLogin(tokenResponse);
        handleAuth(authFn, "login");
    }

    return (
        <div className="px-[30px] flex flex-col h-full">
            <div>
                <h1 className="text-2xl font-semibold mb-[5px]">Log in to BetterCampus</h1>
                <p className="text-gray-500">Over 1.5 million students made their Canvas better</p>
            </div>
            <div className="flex flex-col gap-[10px] mt-[10px]">
                <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                    {loginState.error && <p className="text-red-500">{loginState.error}</p>}
                    <GoogleLogin onSuccess={handleGoogleLogin} onError={() => { }} />
                    {loginState.loading && <div><Loader2 className="w-4 h-4 animate-spin" /></div>}
                </GoogleOAuthProvider>
            </div>
        </div>
    );
};

export default LoginGoogle;
